import React, { Fragment, Suspense, useContext } from 'react'
import { Outlet } from 'react-router-dom'
import { AuthContext } from '../context/auth-context'
import Sidebar from './components/Sidebar'
import FreeTrial from '../pages/FreeTrial'
import { CubeLoader } from '@/components/ui'
import { useNotificationsSubscription } from '@/hooks/useNotificationsSubscription'

const AppLayout = () => {
    const { onboarding } = useContext(AuthContext)
    useNotificationsSubscription()

    return (
        <Fragment>
            <Sidebar appName={import.meta.env.VITE_NAME} />
            <main className="main-content">
                <div className="container-fluid content-inner">
                    <div className="page-content">
                        <Suspense fallback={<CubeLoader size="default" fullScreen={false} />}>
                            {onboarding === true ? <FreeTrial /> : <Outlet />}
                        </Suspense>
                    </div>
                </div>
            </main>
        </Fragment>
    )
}
export default AppLayout
